<template>
    <Badge
        :background-colour="status.background_colour"
        :text-colour="status.text_colour"
    >
        {{ status.label }}
    </Badge>
</template>

<script>
import Badge from '@/components/Badge';

export default {
    components: {
        Badge,
    },
    props: {
        status: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>
